import { useMemo } from 'react';

import { ROUTES } from '@/common';
import { OrganizationTypes } from '@/common/constants';
import { useCurrentOrganization } from '@/modules/core/hooks';
const useGetCIPReportURL = () => {
  const {
    observingDefault: { id: defaultId, type: defaultType },
    observingOrganization: { id, type },
  } = useCurrentOrganization();

  const isEmployerObserving = useMemo(
    () => type === OrganizationTypes.employer || type === OrganizationTypes.company,
    [type]
  );

  const isEmployer = useMemo(
    () => defaultType === OrganizationTypes.employer || defaultType === OrganizationTypes.company,
    [defaultType]
  );

  const currentURL = useMemo(() => {
    if (isEmployerObserving) {
      return `${ROUTES.CIP_STATUS_REPORT}?employerId=${id}&tab=BREAKDOWN`;
    }
    if (isEmployer) {
      return `${ROUTES.CIP_STATUS_REPORT}?employerId=${defaultId}&tab=BREAKDOWN`;
    }
    return `${ROUTES.CIP_STATUS_REPORT}?tab=BREAKDOWN`;
  }, [defaultId, id, isEmployer, isEmployerObserving]);
  return currentURL;
};
export default useGetCIPReportURL;
